import logo from "../../assets/logo.png";
import { NavbarLinks } from "./navbar.links";

export const NavbarPC = () => {
  return (
    <div className="navbar">
      <img src={logo} alt="Logo" className="navbar-logo" />
      <NavbarLinks />
    </div>
  );
};
